/**
 * La colección expandida de la primera —y única— fila de una respuesta OData.
 *
 * Estas consultas filtran por `BookingDetailId eq N` y solo les interesa lo que viene en el
 * `$expand`. El código leía `res.value[0].Campo` directo y, cuando la consulta fallaba, el `catch`
 * no devolvía nada: la saga guardaba `undefined` en el store y el consumidor hacía `pickupDrop.length`
 * sobre eso. No era un toast y seguir — se caía el panel completo del booking (grilla de productos,
 * comentarios, pasajeros) con un TypeError, y solo se recuperaba recargando la página.
 *
 * Además el chequeo de vacío estaba escrito `.legth`, así que nunca se cumplía; daba igual porque
 * devolver el arreglo vacío o `[]` es lo mismo, pero deja claro que esa rama nunca corrió.
 *
 * Devolver siempre un arreglo es lo que corta la cadena: sin fila, sin campo o con la consulta
 * caída, el panel se dibuja vacío en vez de romperse.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const coleccionExpandida = <T = any>(respuesta: any, campo: string): T[] => {
  const fila = respuesta?.value?.[0]
  const coleccion = fila?.[campo]

  return Array.isArray(coleccion) ? coleccion : []
}
